import React, { memo } from "react";
import GiSandsOfTime from "../../../constants/icons/Gi/GiSandsOfTime";

function SectionLoader() {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        zIndex: 9999,
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div
          style={{ marginBottom: "15px", fontSize: "40px", color: "#324DC7" }}
        >
          Please Wait ............
        </div>
        <div style={{ marginBottom: "20px" }}>
          <GiSandsOfTime size={60} style={{ color: "#FF6636" }} />
        </div>
        <div style={{ fontWeight: 700 }}>
          We are loading questions for the next section.
        </div>
      </div>
    </div>
  );
}

export default memo(SectionLoader);
